const moduleKey = 'CORPORATE';

export const corporateTypes = {
  LOAD_REQUESTED: moduleKey + "_LOAD_REQUESTED",
  LOADED: moduleKey + "_LOADED",
  SET_TABLE_CONFIG: moduleKey + "_SET_TABLE_CONFIG",
  SET_TABLE_CONFIG_FILTER: moduleKey + "_SET_TABLE_CONFIG_FILTER",
  CHANGE_TAB: moduleKey + '_CHANGE_TAB',
  CLOSE_TAB: moduleKey + '_CLOSE_TAB',
  CREATE_TAB: moduleKey + '_CREATE_TAB',
  GET_DETAIL_REQUESTED: moduleKey + '_GET_DETAIL_REQUESTED',
  GET_DETAIL_LOADED: moduleKey + '_GET_DETAIL_LOADED'
};

export const corporateActions = {
  loadRequested: (tableConfig) => ({ type: corporateTypes.LOAD_REQUESTED, tableConfig }),
  loaded: (data) => ({ type: corporateTypes.LOADED, payload: { data } }),
  setTableConfig: (key, value) => ({ type: corporateTypes.SET_TABLE_CONFIG, key, value }),
  setTableConfigFilter: (key, value) => ({ type: corporateTypes.SET_TABLE_CONFIG_FILTER, key, value }),
  changeTab: (key) => ({ type: corporateTypes.CHANGE_TAB, key }),
  closeTab: (key) => ({ type: corporateTypes.CLOSE_TAB, key }),
  createTab: (key, title) => ({ type: corporateTypes.CREATE_TAB, key, title }),
  getDetail: (id, index) => ({ type: corporateTypes.GET_DETAIL_REQUESTED, id, index }),
  getDetailLoaded: (data, index) => ({ type: corporateTypes.GET_DETAIL_LOADED, payload: { data }, index })
};
